<template>
  <div
    class="top-menu tpmen"
    :class="[
      { 'tpmen_focus-mode': focusMode },
      { 'tpmen_focus-mode_visible': showInFocusMode && focusMode },
    ]"
    @mouseleave="handleMouseleave"
    @mouseenter="handleMouseenter"
  >
    <div class="tpmen_content">
      <div class="tpmen_content_inner">
        <ReactComponent
          name="LogoSelector"
          class="inline-block w-auto h-auto tpmen_logo"
        />
        <router-link
          v-if="showUpgradeButton && globals_window_size.width <= 1260"
          class="gw_btn gw_btn_primary weight_500 text-medium my-auto"
          style="position: absolute; left: 14rem; z-index: 4"
          data-tst="btn_go_premium"
          v-bind="
            gameformatStarter || gameformatPremium
              ? {
                  variant: 'outline',
                  bgColor: 'primary',
                  color: 'primary',
                }
              : { bgColor: 'primary' }
          "
          :to="{ name: 'SubscriptionOverview', query: { gm_type: gameformat?.gm_type } }"
        >
          <i
            class="mdi-crown mdi mr-1"
            style="font-size: 1.25em"
          ></i>
          {{ gameformatStarter || gameformatPremium ? $t('btn.go_elite') : $t('btn.upgrade') }}
        </router-link>

        <div class="tpmen_main-nav">
          <MainNav />
        </div>
        <div class="tpmen_right">
          <router-link
            v-if="showUpgradeButton && globals_window_size.width > 1260"
            class="gw_btn gw_btn_primary weight_500 text-medium my-auto"
            data-tst="btn_go_premium"
            v-bind="
              gameformatStarter || gameformatPremium
                ? {
                    variant: 'outline',
                    bgColor: 'primary',
                    color: 'primary',
                  }
                : { bgColor: 'primary' }
            "
            :to="{
              name: 'SubscriptionOverview',
              query: { gm_type: gameformat?.gm_type },
            }"
          >
            <i
              class="mdi-crown mdi mr-1"
              style="font-size: 1.25em"
            ></i>

            {{ gameformatStarter || gameformatPremium ? $t('btn.go_elite') : $t('btn.upgrade') }}
          </router-link>

          <UploadBtn
            class="my-auto"
            data-tst="upload_button"
          />
          <UploadsProgress />

          <div
            id="appbar_focus_mode"
            class="mdi mdi-crown tpmen_icon icon_btn csst csst_nm"
            :class="
              focusMode
                ? 'mdi-image-filter-center-focus'
                : 'mdi-image-filter-center-focus-strong-outline'
            "
            @click="switchFocusMode"
          >
            <div
              class="csst_content pa-2 text-nowrap"
              style="transform: translate(0, 2.5rem)"
              v-html="
                $t('hotkeys.focus_mode_key', {
                  key: hotkeys.focus_mode.displayCombination,
                })
              "
            ></div>
          </div>

          <HelpMenu />

          <div
            class="mdi mdi-cog-outline tpmen_icon icon_btn csst csst_nm"
            @click="openSettings"
          >
            <div
              class="csst_content pa-2 text-nowrap"
              style="transform: translate(0, 2.5rem); right: 0rem"
              v-html="$t('tooltips.settings')"
            ></div>
          </div>

          <SettingsMenu />
          <router-link
            v-if="$store.getters.sol_eliteTierPurchased"
            class="h-100"
            :class="links_menu[1].pathName === $route.name ? 'router-link-active' : ''"
            :to="{ name: 'UserCredits' }"
            data-tst="study_menu_link_main"
          >
            <CreditsBalanceCard
              class="h-100"
              style="--padding-text: 0 0 0 0.5rem"
            />
          </router-link>
        </div>
      </div>
    </div>
    <div
      v-show="focusMode"
      class="tpmen_focus-mode_trigger"
    ></div>
  </div>
</template>

<script>
import Logo from '@/assets/logo.svg'
import tier_mix from '@/mixins/tier_mix'
import links_mix from '@/mixins/links_mix'
import prompt_mix from '@/mixins/prompt_mix'
import SettingsMenu from '@/components/AppBar/SettingsMenu'
import HelpMenu from '@/components/AppBar/HelpMenu'
import CreditsBalanceCard from '@/components/NavCard/CreditsBalanceCard.vue'
import ReactComponent from '@/components/React/ReactComponent.vue'
import UploadsProgress from './UploadsProgress'
import UploadBtn from './UploadBtn'
import MainNav from './MainNav'

export default {
  name: 'AppBar',
  components: {
    Logo,
    ReactComponent,
    UploadsProgress,
    UploadBtn,
    MainNav,
    SettingsMenu,
    HelpMenu,
    CreditsBalanceCard,
  },
  mixins: [tier_mix, links_mix, prompt_mix],
  props: {
    focusMode: Boolean,
  },
  data() {
    this.namespace = '' // tier_mix needs namespace
    return {
      closeAccountMenu: true,
      showLangs: false,
      showInFocusMode: false,
      fTimeout: -1,
    }
  },
  methods: {
    handleMouseenter() {
      if (this.focusMode) {
        this.fTimeout = setTimeout(() => {
          this.showInFocusMode = true
        }, 120)
      }
    },
    handleMouseleave() {
      if (this.focusMode) {
        clearTimeout(this.fTimeout)
        this.showInFocusMode = false
      }
    },
    switchFocusMode() {
      this.$store.dispatch('globals_focus_mode')
      if (this.$store.getters.focus_mode) {
        this.pr_dispatchMessage({ id: 'focus' })
      }
    },
    openSettings() {
      this.$store.dispatch('router_set_dialogs', 'settings-dialog')
    },
  },
  computed: {
    showUpgradeButton() {
      return !this.gameformat
        ? this.nadaPurchased
        : !this.gameformatSubscribed ||
            this.gameformatTrial ||
            this.gameformatStarter ||
            this.gameformatPremium
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    globals_window_size() {
      return this.$store.getters.globals_window_size
    },
  },
  watch: {
    focusMode(bool) {
      if (!bool) {
        this.showInFocusMode = false
      }
    },
  },
}
</script>
<style lang="scss">
.tpmen_icon {
  font-size: 1.5rem;
  width: 2rem;
  height: 2rem;
  margin: auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss" scoped>
.mocked-browser-nav-height {
  height: 5rem;
}
.tpmen {
  z-index: 6;
  --top-menu-height: 2.5rem;
  --transition-duration: 0.22s;
  --z-index: 2;
  --z-index-hover: 10;
  z-index: var(--z-index);
  height: var(--top-menu-height);
  flex-shrink: 0;
  position: relative;
  transition: var(--transition-duration);
  &:hover {
    --z-index: var(--z-index-hover);
  }
  &_content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 3;
    box-shadow: 0px 0px 2px 1px var(--clr-black-0);
    &_inner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      max-width: 100vw;
      width: 100vw;
    }
    background-color: var(--clr-black-1);
    height: var(--top-menu-height);
    bottom: 0;
    width: 100vw;
    position: absolute;
    transition: inherit;
  }
  &_focus-mode {
    height: 0;
    &_visible {
      .tpmen_content {
        transform: translateY(var(--top-menu-height));
        box-shadow: 0px 0px 4px 2px var(--clr-black-0);
      }
    }
    &_trigger {
      z-index: 2;
      height: 0.75rem;
      position: absolute;
      left: 0;
      top: 0;
      width: 100vw;
    }
  }
  &_right {
    display: flex;
    grid-gap: 0.5rem;
    position: absolute;
    right: 0.375rem;
    align-items: center;
    height: 100%;
  }
  &_logo {
    margin: auto auto auto 8px;
    position: relative;
    z-index: 2;
    height: 100%;
  }

  &_main-nav {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.logo {
  fill: var(--clr-grey-2);
  transition: 0.2s;
  &:hover {
    fill: var(--clr-primary) !important;
  }
}
</style>
